import { AlertCard } from "@truevault/aquilo";
import { Link } from "react-router-dom";
import React from "react";
import {
  CookieScanner,
  CookieScannerProps,
} from "../../components/organisms/cookies/CookieScanner";
import { Routes } from "../../root/routes";

export const CookieScannerTab: React.FC<CookieScannerProps> = (props) => {
  const instructions = (
    <div className="tw-boundary">
      <AlertCard
        variant="info"
        description={
          <>
            Add and scan your website URL below to get a list of cookies on your site. Designate a
            “Type” and “Data Recipient” for each cookie, or click “Ignore” if you plan to remove
            that cookie. These results will facilitate a chart of cookies you can add to your
            Privacy Policy as an embeddable asset{" "}
            <Link to={Routes.privacyCenter.privacyPolicy} className="underline">
              here
            </Link>
            .
            <br />
            <br />
            Note: If you have GDPR enabled this chart will automatically appear in your GDPR
            disclosure.
          </>
        }
      />
    </div>
  );

  return (
    <>
      <CookieScanner {...props} showDeveloperInstructions={false} instructions={instructions} />
    </>
  );
};
